export const MAX_SELECTABLE_FILES = 5;

export type FileTranslationsUploadType = {
  acceptedFileTypes: string;
  unsupportedFileTypes: string[];
  extensions: string[];
  filesInstructions: string;
  mobileFileInstructions?: string[];
  filesText: string;
  fileTypesText: string;
  maxFiles: number;
  maxFileSizesByType: {
    [key: string]: number;
  };
};

export const FileTranslationsUploadOptions: {
  [key: string]: FileTranslationsUploadType;
} = {
  TRANSLATIONS: {
    acceptedFileTypes: '.txt, .docx, .pdf, .eml, .msg',
    unsupportedFileTypes: [],
    extensions: [
      '.txt',
      '.docx',
      '.pdf',
      '.eml',
      '.msg',
    ],
    filesInstructions: 'Max 5 files | Max 300kb per file',
    mobileFileInstructions: [
      'Max 5 files | Max 300kb per file',
    ],
    filesText: 'Text file type(s): ',
    fileTypesText: '.txt, .docx, .pdf, .eml, .msg',
    maxFiles: 5,
    maxFileSizesByType: {
      'txt': 307200,    // 300kb for text files
      'docx': 307200,   // 300kb for docx files
      'pdf': 307200,    // 300kb for pdf files
      'eml': 307200,    // 300kb for email files
      'msg': 307200,    // 300kb for msg files
    },
  },
};

export const FileTypes: { [key: string]: any } = {
  TRANSLATIONS: {
    TXT: 'TXT' as const,
    DOCX: 'DOCX' as const,
    PDF: 'PDF' as const,
    EML: 'EML' as const,
    MSG: 'MSG' as const,
  },
};

export const FileUploadErrorMessages = {
  FILE_UPLOAD_FAILED: 'Upload failed, Please try again!',
  FILE_UPLOAD_INVALID_FILE_NAME: 'Duplicate translation: A translated file with this name and language already exists.',
  FILE_UPLOAD_INVALID_FILE_TYPE: 'Unsupported file type. Use .txt, .docx, .pdf, .eml, or .msg only.',
  FILE_UPLOAD_SCANNED_PDF: "Scanned PDFs aren't supported for translation.",
  FILE_UPLOAD_FILE_LIMIT_EXCEEDED_TEXT: 'File limit reached. Maximum 5 files can be uploaded at once.',
}


